<template>
    <div
            class="home-compare-card tw-border tw-border-lighterGrayV2 tw-rounded-lg tw-border-solid tw-bg-white "
            ref="homeCompareCard"
    >
        <template>
            <div
                    class="home-compare-card-header tw-border-b tw-rounded-b-none tw-border-lighterGrayV2 tw-border-solid
                    tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-3 tw-self-stretch tw-p-5
                    lg:tw-flex-row lg:tw-justify-between lg:tw-px-8 lg:tw-py-6"
            >
            <span class="tw-text-blackV2 tw-text-sm tw-font-semibold tw-font-openSans tw-leading-tight lg:tw-text-base">
                ZIP Code
                <span class="tw-font-bold">{{ zipcode }}</span>
            </span>
                <div class="tw-inline-flex tw-items-start tw-gap-5">
                    <div class="tw-flex tw-justify-start tw-items-center tw-gap-2">
                        <div class="tw-w-3 tw-h-3 tw-bg-branding-primary-color tw-rounded-full" />
                        <div
                                class="tw-justify-start tw-text-blackV2 tw-text-xs tw-font-semibold tw-font-openSans
                                       lg:tw-text-base"
                        >
                            Your home
                        </div>
                    </div>
                    <div class="tw-flex tw-justify-start tw-items-center tw-gap-2">
                        <div class="tw-w-3 tw-h-3 tw-bg-lighterGrayV2 tw-rounded-full" />
                        <div
                                class="tw-justify-start tw-text-blackV2 tw-text-xs tw-font-semibold tw-font-openSans
                                       lg:tw-text-base"
                        >
                            Other homes
                        </div>
                    </div>
                </div>
            </div>
            <div
                    class="home-compare-card-content tw-flex tw-flex-col tw-items-start tw-self-stretch
                           lg:tw-flex-row lg:tw-flex-wrap tw-mt-3"
            >
                <home-compare-chart
                        :loading="false"
                        :comparison="homeComparisons[0]"
                        :comparison-descriptions="plunkHomeCompare.comparison_descriptions"
                        :custom-width="chartWidth"
                        :widest-bar-factor="140"
                        class="lg:tw-w-1/2"
                />
                <home-compare-chart
                        :loading="false"
                        :comparison="homeComparisons[1]"
                        :comparison-descriptions="plunkHomeCompare.comparison_descriptions"
                        :custom-width="chartWidth"
                        :widest-bar-factor="140"
                        class="lg:tw-w-1/2"
                />
                <b-collapse
                        id="more-professionals-button-id"
                        v-model="viewMoreVisible"
                        class="lg:tw-flex lg:tw-flex-row tw-w-full tw-flex-wrap"
                >
                    <template
                            v-for="(comparison, index) in homeComparisons"
                    >
                        <home-compare-chart
                                v-if="index >= 2 && viewMoreVisible"
                                :key="index"
                                :loading="false"
                                :comparison="comparison"
                                :comparison-descriptions="plunkHomeCompare.comparison_descriptions"
                                :custom-width="chartWidth"
                                :widest-bar-factor="140"
                                class="lg:tw-w-1/2"
                        />
                    </template>
                </b-collapse>
            </div>
            <div
                    class="home-compare-card-footer tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3
                    tw-self-stretch tw-pt-0 tw-pb-8 tw-px-8"
            >
                <b-button
                        v-if="homeComparisons.length > 2"
                        class="show-more-charts-button ms-btn"
                        variant="secondary"
                        size="lg"
                        :aria-expanded="viewMoreVisible ? 'true' : 'false'"
                        aria-controls="more-professionals-button-id"
                        @click="viewMoreVisible = !viewMoreVisible"
                >
                    {{ viewMoreVisible ? 'Show Less' : 'Show More' }}
                    <i
                            :class="[viewMoreVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down']"
                            class="tw-text-xl tw-not-italic tw-font-black !tw-pr-0"
                            aria-hidden="true"
                    />
                </b-button>
            </div>
        </template>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import HomeCompareChart from "@milestoneslabs/milestones-ui-kit/src/components/HomeCompareChart/HomeCompareChart.vue";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

    export default {
        name: "HomeCompareCard",
        mixins: [IsMobileMixin],
        components: {
            HomeCompareChart,
        },
        data() {
            return {
                componentWidth: 0,
                viewMoreVisible: false,
            };
        },
        computed: {
            ...mapGetters({
                plunkValuation: 'getPlunkValuation',
                plunkHomeCompare: 'getPlunkHomeCompare',
                plunkFetchFinish: 'getPlunkFetchFinish',
                getCoreProperty: 'getCoreProperty',
            }),
            ...mapState({
                corePropertyLoading: state => state.coreProperties.corePropertyLoading
            }),
            loading() {
                return !this.plunkFetchFinish;
            },
            chartWidth() {
                if (this.isDesktop) {
                    return 0.4 * this.componentWidth;
                }

                return this.componentWidth - 40;
            },
            homeComparisons() {
                if (!this.plunkHomeCompare?.comparisons) {
                    return [];
                }
                return this.plunkHomeCompare.comparisons.slice(0, this.maxCharts);
            },
            zipcode() {
                return this.getCoreProperty?.addresses?.getFirst()?.postalCode || null;
            },
        },
        methods: {
            ...mapActions({
                loadCoreProperties: 'loadCoreProperties',
            }),
            setComponentWidth() {
                this.componentWidth = this.$refs.homeCompareCard?.clientWidth || 0;
            },
        },
        mounted() {
            this.setComponentWidth();
            if (!this.getCoreProperty.exists && !this.corePropertyLoading) {
                this.loadCoreProperties();
            }
        },
        beforeMount() {
            window.addEventListener('resize', this.setComponentWidth);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setComponentWidth);
        },
    };
</script>
